export default {
    namespaced: true,
    state: {
        loader: false,
        requests: 0
    },
    getters: {
        loader(state) {
            return state.loader;
        }
    },
    actions: {
        pending({commit}) {
            commit("UPDATE_PENDING");
        },
        done({commit}) {
            commit("UPDATE_DONE");
        }
    },
    mutations: {
        UPDATE_PENDING(state) {
            if (state.requests === 0)
                state.loader = true;

            state.requests++;
        },
        UPDATE_DONE(state) {
            if (state.requests >= 1)
                state.requests--;

            if (state.requests === 0)
                state.loader = false;
        }
    }
}